import { toLocaleISOString } from '@softline/core';

export function setTimeOfDate(value: Date | string, isoTime: string): Date | null {
  const date = value instanceof Date ? value : new Date(toLocaleISOString(value));

  if (isNaN(date.getTime())) {
    return null;
  }

  const dateAndTimeParts = date.toISOString().split('T');

  if (dateAndTimeParts.length < 1) return null;

  return new Date(dateAndTimeParts[0] + isoTime);
}
